import React, {useState} from 'react';
// import {onlineProcessesService} from "../../services";
import {useLoader} from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralBigNumber from '@quadral/quadral-component-common/dist/components/bigNumber'
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container'
import QuadralCard from '@quadral/quadral-component-common/dist/components/card'
import QuadralButtonIcon from "@quadral/quadral-component-common/dist/components/buttonIcon";
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelope, faEuroSign, faEye, faFileLines, faPen, faPeopleGroup, faUser} from '@fortawesome/free-solid-svg-icons';
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography'
import Grid from '@mui/material/Grid';
import UpdatePersonModal from './UpdatePersonModal';
import Chip from '@mui/material/Chip';


const Details = ({getDocStatusCount, roles, mapReferences, participation, signatoryPerson, persons, ...props}) => {

    const {showLoader, hideLoader} = useLoader();
    // const [displayImpersonateBtn, setDisplayImpersonateBtn]= useState(false);
    // const [sendMailModalOpen, setSendMailModalOpen]= useState(false);
    const [selectedPerson, setSelectedPerson] = useState([])
    const [open, setOpen] = useState(false);

    // const participationStatusOptions = [
    //     {
    //         label: "En attente de lancement",
    //         value: "en_attente_de_lancement",
    //     },{
    //         label: "En attente de connexion",
    //         value: "en_attente_de_connexion",
    //     },{
    //         label: "En attente de réponse",
    //         value: "en_attente_reponse",
    //     },{
    //         label: "En attente des PJ",
    //         value: "en_attente_des_pj",
    //     },{
    //         label: "Contrôle en cours",
    //         value: "controle_en_cours",
    //     },{
    //         label: "Compléments attendu",
    //         value: "complements_attendu",
    //     },{
    //         label: "Compléments fournis",
    //         value: "complements_fournis",
    //     },{
    //         label: "Contrôlée",
    //         value: "controlee",
    //     },{
    //         label: "Validée",
    //         value: "reponse_validee",
    //     },{
    //         label: "Annulée",
    //         value: "annulee",
    //     }
    // ]

    // const statusOptions = [
	// 	{   label: 'Retours à analyser - interne',    value: 'Retours_a_analyser_interne', },
	// 	{   label: 'Retours à analyser - mandant',    value: 'Retours_a_analyser_externe', },
    //     {   label: 'Escaladé interne',    value: 'Escalade_interne', },
	// 	{   label: 'Escaladé mandant',    value: 'Escalade_externe', },
    //     {   label: "Traité", value: "Traite" },
    //     {   label: "Envoyé", value: "Envoyé" },
    // ];

    const personsSynthetic=[
        {
            label:  'Nom et prénom',
            value:  `${participation?.firstname} ${participation?.lastname}`,
        },
        {
            label:  'Date de naissance',
            value:  `${getFormatDate(signatoryPerson?.birthDate)}`,
        },
        {
            label:  'Nationalité',
            value:  `${signatoryPerson?.nationalityPerCategory}`,
        },
        {
            label:  'Téléphone mobile',
            value:  `${signatoryPerson?.phoneNumber}`,
        },
        {
            label:  'Email',
            value:  `${signatoryPerson?.email}`,
        },
        {
            label:  'Canal',
            value: (() => {
                const channel = participation?.communicationChannel;
                if (!channel) return null;

                const icon = {
                    email: faEnvelope,
                    papier: faFileLines,
                }[channel];

                return (
                    <QuadralBadge
                        label={channel}
                        color="secondary"
                        style={{color:'#000', textTransform: 'capitalize'}}
                        icon={<FontAwesomeIcon icon={icon}/>}
                    />
                );
            })(),
        },
        {
            label:  'Téléphone domicile',
            value:  `${signatoryPerson?.homePhoneNumber}`,
        },
        {
            label:  'Adresse',
            value:  `${participation?.assetAddressNumber} ${participation?.assetAddressStreet}, ${participation?.assetAddressCity} ${participation?.assetAddressPostcode}`,
        },
        {
            label:  'Code contrat',
            value:  <Chip
                        label={participation?.contractCode}
                        variant="filled"
                        sx={{
                            bgcolor: "#EEF2FF",
                            color: "text.primary",
                            borderRadius: "10px",
                            fontWeight: 500,
                            fontSize: 14,
                            height: 40,
                        }}
                    />,
        },
    ]

    const rfrSynthetic = [
        {
            label: 'Total des revenus mensuels déclarés',
            value: 'ADD_VALUE_HERE',
        },
        {
            label: 'Total des prestations déclarées',
            value: 'ADD_VALUE_HERE',
        },
        {
            label: 'RFR total',
            value:  participation?.totalRFR != null
                    ? `${participation.totalRFR.toLocaleString('fr-FR')} €`
                    : ''
        },
    ];

    // function getStatusLabel(statusValue){
    //     if(!statusValue) return "inconnu";
    //     const found = participationStatusOptions.find(option => option.value === statusValue);
    //     return found ? found.label : statusValue
    // }

    function getFormatDate(rawDate){
        if(!rawDate) return "inconnu";
        const date = new Date(rawDate);
        const day = String(date.getDate()).padStart(2,'0');
        const month = date.toLocaleString('fr-FR', {month: 'long'});
        const year = date.getFullYear();
        return day + " " + month + " " + year;
    }

    // function impersonateToCandidate(){
    //     showLoader();
    //     if(!props.participation?.uniqueContractCode) return;
    //     onlineProcessesService.impersonate(props.participation?.uniqueContractCode)
    //         .then(response => {
    //             hideLoader();
    //             window.open(response,"_blank");
    //         })
    //         .catch(err => {
    //             hideLoader();
    //             console.error(err);
    //             props.quadralToast.error('Impossible de renseigner la participation.');
    //         });
    // }

    function calculateAge(birthDateString) {
        const birthDate = new Date(birthDateString);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age;
    }

    // useEffect(()=>{
    //     const hasRole = roles?.includes("user.impersonate");
    //     setDisplayImpersonateBtn(hasRole);
    // },[roles])

    return(<>
        <QuadralContainer orientation='row' sx={{gap: '32px', paddingBottom: '1rem'}}>
            <QuadralBigNumber
                title='Bailleur'
                value={props?.bailleur}
            />
            <QuadralBigNumber
                title='Pièces à vérifier'
                value={getDocStatusCount("attente_verification")}
                color='info'
            />
            <QuadralBigNumber
                title='Pièces à fournir'
                value={getDocStatusCount("a_fournir")}
                color='error'
            />
        </QuadralContainer>
        <Grid container spacing="15px">
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Informations du signataire principal'
                    icon={<FontAwesomeIcon icon={faUser}/>}
                    sx={{ width: '100%', height: 'stretch' }}
                    action={
                        <QuadralButtonIcon 
                            icon={ <FontAwesomeIcon style={{fontSize:'1rem'}} icon={faPen}/> }
                            onClick={() => {
                                setSelectedPerson(signatoryPerson);
                                setOpen(true);
                            }}
                        />
                    }
                >
                    <Grid container spacing="15px">
                        {personsSynthetic.map((item) => (
                            <Grid sx={{padding: '0.5rem 1rem', display:'flex', flexDirection:'column'}} size={{md: 4, sm: 12, xs: 12}}>
                                <QuadralTypography variant='dataLabel'>{item.label}</QuadralTypography>
                                {(item.value && item.value !== 'undefined' && item.value !== 'inconnu') ? (
                                    <QuadralTypography sx={{wordBreak: 'break-word'}}variant='dataValue'>{item.value || ' '}</QuadralTypography>
                                ) : (
                                    <QuadralTypography sx={{wordBreak: 'break-word', textTransform:'none'}}variant='dataLabel'>Non renseigné</QuadralTypography>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </QuadralCard>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Revenus et prestations'
                    icon={<FontAwesomeIcon icon={faEuroSign}/>}
                    sx={{ width: '100%', height: 'stretch' }}
                    action={ 
                        <QuadralButtonIcon 
                            icon={<FontAwesomeIcon style={{fontSize:'1rem'}} icon={faEye}/>}
                            onClick={() => {
                                props.setTabValue("3")
                            }}/>}
                >
                    <QuadralContainer orientation='column'>
                        {rfrSynthetic.map((item) => (
                            <QuadralContainer sx={{padding: '0.5rem 1rem', display:'flex', flexDirection:'row', justifyContent: 'space-between'}} size={{md: 3, sm: 4, xs: 12}}>
                                <QuadralTypography variant='dataValue'>{item.label}</QuadralTypography>
                                <QuadralTypography sx={{wordBreak: 'break-word'}}variant='dataValue'>{item.value || ' '}</QuadralTypography>
                            </QuadralContainer>
                        ))}
                        
                    </QuadralContainer>
                </QuadralCard>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <QuadralCard
                    title='Personnes'
                    icon={<FontAwesomeIcon icon={faPeopleGroup}/>}
                    sx={{ width: '100%', height: 'stretch' }}
                    action={ 
                        <QuadralButtonIcon 
                            icon={<FontAwesomeIcon style={{fontSize:'1rem'}} icon={faEye}/>}
                            onClick={() => {
                                props.setTabValue("2")
                            }}/> }
                >
                    <Grid container spacing="15px">
                        {persons.map((person) => {
                            return(<>
                            <Grid sx={{display:'flex', flexDirection:'column'}} size={{md: 6, sm: 6, xs: 12}}>
                                <QuadralCard 
                                    title={`${person.lastname} ${person.firstname}`} 
                                    variant='small' 
                                    sx={{
                                        minWidth: 'auto',
                                        width: '100%',
                                        height: 'stretch !important',
                                    }}
                                    action={
                                        <QuadralButtonIcon 
                                            icon={ <FontAwesomeIcon style={{fontSize: '0.8rem'}} icon={faPen}/> }
                                            onClick={() => {
                                                setSelectedPerson(person);
                                                setOpen(true);
                                        }} />
                                    }
                                >
                                    {
                                        [
                                            person.occupantType != null &&
                                                mapReferences(person.occupantType, 'PERSON_RECORD_OCCUPANT_TYPE'),

                                            person.birthDate != null &&
                                                calculateAge(person.birthDate),

                                            person.familySituation != null &&
                                                mapReferences(person.familySituation, 'PERSON_RECORD_FAMILY_SITUATION'),

                                            person.householdLink != null &&
                                                mapReferences(person.householdLink, 'PERSON_RECORD_HOUSE_HOLD_LINK'),
                                        ].filter(Boolean).join(' / ')
                                    }
                                </QuadralCard>
                            </Grid>
                        </>)})}
                    </Grid>
                </QuadralCard>
            </Grid>
        </Grid>
        <UpdatePersonModal
            selectedPerson={selectedPerson}
            open={open}
            setOpen={setOpen}
            showLoader={showLoader}
            hideLoader={hideLoader}
            participation={participation}
            mapReferenceToOptions={props.mapReferenceToOptions}
            refreshPersonsData={props.refreshPersonsData}
            quadralToast={props.quadralToast}
        />
    </>);
};

export default Details;
